import React from 'react';

// 3D tilt su dispositivi con puntatore fine (mouse). Disattivo su touch / reduced-motion.
export function useTilt({ max = 8 } = {}) {
  const ref = React.useRef(null);
  const enabled = React.useRef(false);

  React.useEffect(() => {
    try {
      const fine = window.matchMedia('(pointer:fine)').matches;
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      enabled.current = fine && !reduce;
    } catch { enabled.current = false; }
  }, []);

  const onMouseMove = React.useCallback((e) => {
    if (!enabled.current) return;
    const el = ref.current; if (!el) return;
    const r = el.getBoundingClientRect();
    const px = (e.clientX - r.left) / r.width;
    const py = (e.clientY - r.top) / r.height;
    const rx = (max / 2 - py * max);
    const ry = (px * max - max / 2);
    el.style.transform = `rotateX(${rx}deg) rotateY(${ry}deg)`;
  }, [max]);

  const onMouseLeave = React.useCallback(() => {
    const el = ref.current; if (!el) return;
    el.style.transform = 'rotateX(0deg) rotateY(0deg)';
  }, []);

  return { ref, onMouseMove, onMouseLeave };
}
